import React, { Component } from "react";
import {
  GET,
  POST,
  UPLOAD,
  Select,
  alert,
  loading,
  NavbarCustomer,
  activeOptions,
  t
} from "../../components/CustomComponent.js";
import { getProfile } from "../../utils/localStorage";
import {
  WORK_REQUEST_UPLOAD_RULES,
  pickFilesByRule,
  compressImageFiles,
  formatText,
  formatFileSize,
  toMB,
} from "../../utils/fileUpload";

const profile = getProfile();

const PRIORITY_ICONS = [
  { match: /emergency/i, icon: "" },
  { match: /high/i, icon: "" },
  { match: /medium/i, icon: "" },
  { match: /low/i, icon: "" },
];
const DEFAULT_PRIORITY_ICON = "";

const getPriorityIcon = (item) => {
  if (item?.icon) return item.icon;
  const found = PRIORITY_ICONS.find((p) => p.match.test(item?.name_en || item?.name_th || ""));
  return found ? found.icon : DEFAULT_PRIORITY_ICON;
};

const IMAGE_RULE = WORK_REQUEST_UPLOAD_RULES.image;
const VIDEO_RULE = WORK_REQUEST_UPLOAD_RULES.video;
const MAX_VIDEOS = VIDEO_RULE.maxFiles;
const DESC_MIN_LENGTH = 30;
const DESC_MAX_LENGTH = 500;

// โหมด super user เลือกได้ทุกลูกค้า/ทุกทรัพย์สิน - เยอะเกินกว่าจะดึงมาทั้งตาราง
// จึงค้นจาก backend ทีละหน้าเมื่อเปิด dropdown (searchCustomers / searchAssets)
const CUSTOMER_SEARCH_LIMIT = 20;
const ASSET_SEARCH_LIMIT = 20;

export default class ServiceRequestCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_super_user: profile?.user_type === "super_user",

      data_customer: [],
      assets: [],
      // โหมด remote ของ Select (เฉพาะ super user): จำคำค้นล่าสุดกันยิงซ้ำ + ธงโหลด
      customer_search_keyword: null,
      customer_search_loading: false,
      asset_search_keyword: null,
      asset_search_customer_id: null,
      asset_search_loading: false,
      categories: [],
      priorities: [],
      own_customer: null,
      default_priority_id: "",

      create_customer_id: "",
      create_asset_id: "",
      create_category_id: "",
      create_priority_id: "",
      create_problem_desc: "",
      create_contact_name: "",
      create_contact_phone: "",
      create_preferred_date: "",
      create_preferred_time: "",

      images: [],
      videos: [],
    };
  }

  async componentDidMount() {
    loading(true);
    // ห้ามอ่าน this.state หลัง await - setState ยังไม่ flush ได้ค่าว่าง (ทำให้ส่งใบแจ้งซ่อมไม่ได้เมื่อซ่อนช่องไว้)
    // จึงให้ GetOptions คืนค่ากลับมาแล้วตั้ง create_* จากค่านั้นโดยตรง
    const options = await this.GetOptions();

    if (!this.state.is_super_user) {
      this.setState({
        create_customer_id: options?.own_customer?.uid || "",
        create_priority_id: options?.priority_id || "",
      });
      await this.GetAssets();
    }
    // super user ไม่ prefetch อะไรเลย - รอผู้ใช้เปิด dropdown แล้วค่อยค้นจาก backend

    loading(false);
  }

  componentWillUnmount() {
    [...this.state.images, ...this.state.videos].forEach((item) => {
      if (item?.url && item.url.startsWith("blob:")) URL.revokeObjectURL(item.url);
    });
  }

  getCustomerDisplayName = (customer) => {
    const lang = localStorage.getItem("lang") || "TH";
    if (lang === "EN") {
      return `${customer?.customer_code || ""} ${customer?.full_name_en || customer?.full_name_th || "-"}`.trim();
    }
    return `${customer?.customer_code || ""} ${customer?.full_name_th || customer?.full_name_en || "-"}`.trim();
  };

  getCustomerContactName = (customer) => `${customer?.contact_first_name || ""} ${customer?.contact_last_name || ""}`.trim();

  // ชื่อ/รหัสตัวหน้าของ asset ใน dropdown - ลำดับ fallback เดียวกับฝั่งแอดมิน (work-requests.js -> getAssetDisplayName)
  // customer/assets (ลูกค้าทั่วไป ไม่ใช่ super user) ไม่มี part_number ติดมาด้วย จึง fallback ไปที่ชื่อ/รหัส asset แทน
  getAssetItemLabel = (asset) =>
    asset?.part_number || asset?.part?.part_number || asset?.part_name || asset?.part?.name || asset?.name || asset?.asset_code || "";

  // รูปแบบเดียวกับฝั่งแอดมิน (getAssetIdentityLine): "<item> : <serial>"
  getAssetIdentityLine = (asset) => {
    const item = this.getAssetItemLabel(asset);
    const serial = asset?.serial_number || "";
    return [item, serial].filter(Boolean).join(" : ") || "-";
  };

  GetOptions = async () => {
    const result = await GET("customer/work-requisitions/options");
    if (result?.status === true) {
      const own_customer = result.data?.customer || null;
      this.setState({
        categories: result.data?.categories || [],
        priorities: result.data?.priorities || [],
        own_customer,
        default_priority_id: result.data?.default_priority_id || "",
        create_contact_name: this.getCustomerContactName(own_customer),
        create_contact_phone: own_customer?.contact_phone || "",
      });

      // ลูกค้าที่ไม่ได้ตั้งระดับความสำคัญไว้ -> ใช้ Medium (ธรรมเนียมเดียวกับแจ้งซ่อมผ่าน QR) ถ้าไม่มี Medium ปล่อยว่างแล้ว handleSubmit แจ้งสาเหตุชัดเจน
      const priorities = result.data?.priorities || [];
      const medium = priorities.find((p) => String(p?.name_en || "").trim().toLowerCase() === "medium");
      return {
        own_customer,
        priority_id: result.data?.default_priority_id || medium?.uid || "",
      };
    }
    return null;
  };

  // dropdown ลูกค้า (super user): ค้นจาก backend ทีละหน้า
  // ไม่ส่ง is_active มา เพราะรายการที่ปิดใช้งานแต่ถูกเลือกไว้ต้องยังแสดงได้ (activeOptions คัดตอน render)
  searchCustomers = async (keyword = "") => {
    const keySearch = String(keyword || "").trim();

    // คำค้นเดิมและมีผลอยู่แล้ว = ไม่ต้องยิงซ้ำ (เปิด-ปิด dropdown ไปมาไม่ควรยิงทุกครั้ง)
    if (keySearch === this.state.customer_search_keyword && this.state.data_customer.length > 0) return;

    this.setState({ customer_search_keyword: keySearch, customer_search_loading: true });

    const result = await GET("admin/customers", {
      page: 1,
      page_size: CUSTOMER_SEARCH_LIMIT,
      data_search: keySearch,
    });

    // ผู้ใช้พิมพ์ต่อไปแล้วระหว่างรอ = ผลชุดนี้ตกรุ่น ทิ้งไปเลย ไม่งั้นรายการจะเด้งกลับไปเป็นของคำค้นเก่า
    if (this.state.customer_search_keyword !== keySearch) return;

    this.setState({
      data_customer: (result?.data || []).map((c) => ({
        ...c,
        group: undefined,
        value: c.uid,
        label: this.getCustomerDisplayName(c),
      })),
      customer_search_loading: false,
    });
  };

  GetAssets = async () => {
    const result = await GET("customer/assets", { page_size: 1000, page: 1 });
    if (result?.status === true) {
      this.setState({ assets: result.data?.assets || [] });
    }
  };

  // dropdown ทรัพย์สิน (super user): ผูกกับลูกค้าที่เลือก -> ให้ backend กรองด้วย customer_id
  // cache key ต้องรวม customer_id ด้วย ไม่งั้นเปลี่ยนลูกค้าแล้วคำค้นเดิมจะไม่ยิงใหม่ (รายการเก่าค้าง)
  searchAssets = async (keyword = "") => {
    const keySearch = String(keyword || "").trim();
    const customerId = this.state.create_customer_id;

    if (!customerId) {
      this.setState({ assets: [], asset_search_keyword: null, asset_search_customer_id: null });
      return;
    }

    if (
      keySearch === this.state.asset_search_keyword &&
      customerId === this.state.asset_search_customer_id &&
      this.state.assets.length > 0
    )
      return;

    this.setState({ asset_search_keyword: keySearch, asset_search_customer_id: customerId, asset_search_loading: true });

    // lite=true: ได้ field ที่ dropdown ใช้ (part / serial / is_active) โดยไม่ join หนัก
    const result = await GET("admin/assets", {
      page: 1,
      page_size: ASSET_SEARCH_LIMIT,
      lite: "true",
      customer_id: customerId,
      data_search: keySearch,
    });

    // พิมพ์ต่อ หรือเปลี่ยนลูกค้าไปแล้วระหว่างรอ = ผลชุดนี้ตกรุ่น ทิ้งไปเลย
    if (this.state.asset_search_keyword !== keySearch || this.state.asset_search_customer_id !== customerId) return;

    this.setState({ assets: result?.data || [], asset_search_loading: false });
  };

  getAssetOptions = () => {
    const { assets } = this.state;
    // super user: backend กรองตามลูกค้ามาให้แล้ว (searchAssets) / ลูกค้าทั่วไป: customer/assets scope ให้อยู่แล้ว
    const list = assets;

    return activeOptions(
      list.map((a) => ({
        is_active: a.is_active,
        value: a.uid,
        label: this.getAssetIdentityLine(a),
      })),
      this.state.create_asset_id
    );
  };

  // -----------------------------------
  // File Helpers
  // -----------------------------------
  mapFilesToItems = (fileList) =>
    Array.from(fileList).map((file) => ({
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
    }));

  // รวมเหตุผลที่ไฟล์ถูกปฏิเสธเป็นข้อความเดียว แล้วแจ้งครั้งเดียว
  // (alert() ของโปรเจกต์จะ "ทิ้ง" ข้อความที่ยิงซ้อนขณะมี modal เปิดอยู่)
  notifyRejectedFiles = ({ wrongType, tooBig, overLimit, rule }, fileType) => {
    const messages = [];

    if (wrongType.length > 0) {
      messages.push(`${t("file_type_not_allowed")}: ${wrongType.join(", ")}`);
    }
    if (tooBig.length > 0) {
      messages.push(`${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${tooBig.join(", ")}`);
    }
    if (overLimit > 0) {
      const key = fileType === "video" ? "max_videos_reached" : "max_images_reached";
      messages.push(formatText(t(key), { count: rule.maxFiles, excess: overLimit }));
    }

    if (messages.length > 0) {
      alert("", "warning", t("warning"), messages.join(" · "));
    }
  };

  // เพิ่มไฟล์เข้า state ตามกติกา: ชนิดไฟล์ -> ขนาดต่อไฟล์ -> จำนวนสูงสุด -> บีบอัดรูป
  // fileType: "image" | "video"
  addFiles = async (fileList, fileType) => {
    const stateKey = fileType === "video" ? "videos" : "images";
    const current = this.state[stateKey] || [];

    const result = pickFilesByRule(fileList, fileType, current.length);
    this.notifyRejectedFiles(result, fileType);
    if (result.accepted.length === 0) return;

    // บีบอัดรูปก่อนเก็บเข้า state เพื่อลดพื้นที่จัดเก็บบน S3 (วิดีโอบีบฝั่ง browser ไม่ได้ ใช้ตามเดิม)
    let files = result.accepted;
    if (fileType === "image") {
      loading(true);
      try {
        files = await compressImageFiles(result.accepted);
      } finally {
        loading(false);
      }
    }

    const newItems = this.mapFilesToItems(files);
    this.setState((prev) => ({ [stateKey]: [...prev[stateKey], ...newItems] }));
  };

  handleDragOver = (e) => e.preventDefault();

  handleImageBrowse = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (files.length) this.addFiles(files, "image");
  };

  handleImageDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      const files = Array.from(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.addFiles(files, "image");
    }
  };

  handleVideoBrowse = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (files.length) this.addFiles(files, "video");
  };

  handleVideoDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      const files = Array.from(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.addFiles(files, "video");
    }
  };

  removeImage = (index) => {
    this.setState((prev) => {
      const images = [...prev.images];
      const [removed] = images.splice(index, 1);
      if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
      return { images };
    });
  };

  removeVideo = (index) => {
    this.setState((prev) => {
      const videos = [...prev.videos];
      const [removed] = videos.splice(index, 1);
      if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
      return { videos };
    });
  };

  uploadAttachments = async (items, folder, fileType) => {
    const uploaded = [];

    const rule = WORK_REQUEST_UPLOAD_RULES[fileType] || WORK_REQUEST_UPLOAD_RULES.image;

    for (const item of items) {
      // backstop: กันไฟล์ใหญ่เกินหลุดมาถึงขั้นอัปโหลด
      if (item?.file && item.file.size > rule.maxSize) {
        alert("", "warning", t("warning"), `${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${item?.name || ""}`);
        return null;
      }

      const res = await UPLOAD(item.file, { folder });

      if (res?.status === true && res?.data?.file_path) {
        uploaded.push({
          file_path: res.data.file_path,
          file_name: item.name || res.data.file_name || null,
          file_type: fileType,
          mime_type: res.data.mime_type || item.type || null,
          file_size: res.data.file_size ?? item.size ?? null,
        });
      } else {
        alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
        return null;
      }
    }

    return uploaded;
  };

  // -----------------------------------
  // Submit
  // -----------------------------------
  handleSubmit = async () => {
    const {
      is_super_user, create_customer_id, create_asset_id, create_category_id, create_priority_id,
      create_problem_desc, create_contact_name, create_contact_phone,
      create_preferred_date, create_preferred_time,
    } = this.state;

    if (is_super_user && !create_customer_id) {
      alert("", "warning", t("warning"), t("select_customer"));
      return;
    }

    if (!create_asset_id) {
      alert("", "warning", t("warning"), t("select_asset_first"));
      return;
    }

    // ช่องระดับความสำคัญถูกซ่อนสำหรับลูกค้า - ถ้าไม่มีค่า default ต้องบอกสาเหตุ ไม่ใช่ "กรอกไม่ครบ" ที่ผู้ใช้แก้เองไม่ได้
    if (!is_super_user && !create_priority_id) {
      alert("", "warning", t("warning"), t("customer_priority_missing"));
      return;
    }

    if (!create_category_id || !create_priority_id || !create_problem_desc) {
      alert("", "warning", t("warning"), t("required_fields"));
      return;
    }

    const descLength = create_problem_desc.trim().length;
    if (descLength < DESC_MIN_LENGTH || descLength > DESC_MAX_LENGTH) {
      alert("", "warning", t("warning"), t("problem_description_length_invalid"));
      return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);

    const image_attachments = await this.uploadAttachments(this.state.images, "work-requisitions/images", "image");
    const video_attachments = await this.uploadAttachments(this.state.videos, "work-requisitions/videos", "video");

    if (image_attachments === null || video_attachments === null) {
      loading(false);
      return;
    }

    const attachments = [...image_attachments, ...video_attachments];

    const body = {
      ...(is_super_user ? { customer_id: create_customer_id } : {}),
      asset_id: create_asset_id,
      work_requisition_categories_id: create_category_id,
      work_requisition_priorities_id: create_priority_id,
      problem_description: create_problem_desc,
      contact_name_1: create_contact_name,
      contact_phone_1: create_contact_phone,
      preferred_date: create_preferred_date,
      preferred_time: create_preferred_time,
      attachments,
    };

    const result = await POST("customer/work-requisitions", body);

    loading(false);

    if (result?.status === true) {
      await alert("#", "success");
      window.location.href = "/cs/work-requests";
    } else {
      alert("", "warning", t("warning"), result?.message || t("fail"));
    }
  };

  render() {
    const {
      is_super_user, data_customer, customer_search_loading, asset_search_loading,
      categories, priorities,
      create_customer_id, create_asset_id, create_category_id, create_priority_id,
      create_problem_desc, create_contact_name, create_contact_phone,
      create_preferred_date, create_preferred_time, images, videos,
    } = this.state;

    const assetOptions = this.getAssetOptions();
    const categoryOptions = categories.map((c) => ({ value: c.uid, label: c.name_th, ...c }));
    // ผู้ใช้ฝั่งลูกค้า (เข้าด้วยเลขผู้เสียภาษี/ลูกค้าปกติ) ไม่เห็นช่องเลือกลูกค้าและระดับความสำคัญ
    // (ระบบใส่ create_customer_id / create_priority_id ให้เองใน componentDidMount แล้วส่งไป backend เหมือนเดิม)
    // เลขลำดับขั้นจึงต้องนับตามส่วนที่แสดงจริง
    let stepNo = 0;
    const nextStep = () => ++stepNo;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        {/* .body มี margin-left 260px เว้นที่ให้เมนูซ้าย - ห้าม override marginLeft ตรงนี้
            ไม่งั้นเนื้อหาจะเลื่อนไปอยู่ใต้เมนู จำกัดความกว้างที่ div ชั้นในแทน */}
        <div className="body p-4 mt-3">
          <div style={{ maxWidth: "900px", marginLeft: "auto", marginRight: "auto" }}>

          <div className="mb-3">
            <span
              className="text-secondary text-14 pointer"
              onClick={() => { window.location.href = "/cs/work-requests"; }}
            >
              <span className="icon me-2">{""}</span>{t("back_to_work_requests")}
            </span>
          </div>

          {/* Header */}
          <div className="rounded-4 p-4 mb-4 text-white" style={{ background: "linear-gradient(90deg, #0f766e, #14b8a6)" }}>
            <h4 className="fw-bold mb-1">{t("create_service_request")}</h4>
            <div className="text-14 opacity-75">{t("fill_details_desc")}</div>
          </div>

          {/* Section 1: Select Customer */}
          {is_super_user && (
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">{nextStep()}</span>
              <h6 className="fw-bold text-dark mb-0">{t("select_customer")} <span className="text-danger">*</span></h6>
            </div>

              <Select
                className="form-control"
                options={activeOptions(data_customer, create_customer_id)}
                value={create_customer_id}
                placeholder={t("select_customer")}
                onSearch={this.searchCustomers}
                loading={customer_search_loading}
                onChange={(e, i) => {
                  this.setState({
                    create_customer_id: e,
                    create_priority_id: i?.priority?.uid || "",
                    create_asset_id: "",
                    create_contact_name: this.getCustomerContactName(i),
                    create_contact_phone: i?.contact_phone || "",
                    // เปลี่ยนลูกค้า = รายการทรัพย์สินชุดเดิมใช้ไม่ได้แล้ว ล้างทิ้งรอค้นใหม่
                    assets: [],
                    asset_search_keyword: null,
                    asset_search_customer_id: null,
                  });
                }}
              />
          </div>
          )}

          {/* Section 2: Select Asset */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">{nextStep()}</span>
              <h6 className="fw-bold text-dark mb-0">{t("select_asset")} <span className="text-danger">*</span></h6>
            </div>

            <Select
              className="form-control"
              options={assetOptions}
              value={create_asset_id}
              placeholder={t("select_asset")}
              onChange={(e) => this.setState({ create_asset_id: e })}
              disabled={is_super_user && !create_customer_id}
              onSearch={is_super_user ? this.searchAssets : undefined}
              loading={asset_search_loading}
            />

            <div className="mt-3">
              <span className="text-success text-13 fw-bold pointer" onClick={() => alert("", "info", t("scan_qr_code"), t("coming_soon"))}>
                <span className="icon me-1">{""}</span>{t("scan_qr_code")}
              </span>
            </div>
          </div>

          {/* Section 3: Problem Description (Request Details merged in) */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">{nextStep()}</span>
              <h6 className="fw-bold text-dark mb-0">{t("problem_description")}</h6>
            </div>

            <div className="row g-3 mb-3">
              <div className="col-12">
                <label className="form-label text-13 text-secondary">{t("req_category")} <span className="text-danger">*</span></label>
                <Select
                  sort={false}
                  className="form-control"
                  options={categoryOptions}
                  value={create_category_id}
                  placeholder={t("select_req_category")}
                  onChange={(e) => this.setState({ create_category_id: e })}
                />
              </div>
            </div>

            {is_super_user && (
            <div className="mb-3">
              <label className="form-label text-13 text-secondary">
                {t("priority_level")} <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
              </label>
              <div className="row g-2">
                {priorities.map((p) => {
                  const selected = create_priority_id === p.uid;
                  return (
                    <div key={p.uid} className="col-6 col-md-3">
                      <div
                        className="rounded-3 border p-2 text-center text-12 fw-bold"
                        style={selected
                          ? { backgroundColor: p.background_color || "#0d6efd", color: p.font_color || "#fff", borderColor: p.background_color || "#0d6efd" }
                          : { borderColor: "#e5e7eb", color: "#495057", opacity: 0.5 }}
                      >
                        <span className="icon me-1">{getPriorityIcon(p)}</span>{p.name_th}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            )}

            <div className="mb-3">
              <label className="form-label text-13 text-secondary">{t("detailed_description")} <span className="text-danger">*</span></label>
              <textarea
                className="form-control rounded-3"
                rows={4}
                maxLength={DESC_MAX_LENGTH}
                placeholder={t("describe_problem_placeholder")}
                value={create_problem_desc}
                onChange={(e) => this.setState({ create_problem_desc: e.target.value })}
              />
              <div className="d-flex justify-content-between text-secondary text-12 mt-1">
                <span>{t("problem_description_hint")}</span>
                <span>{create_problem_desc.length}/{DESC_MAX_LENGTH}</span>
              </div>
            </div>

            <div>
              <label className="form-label text-13 text-secondary mb-2">{t("attach_photos_documents")}</label>

              {/* Images Dropzone */}
              <label className="form-label text-13 text-secondary mb-1">
                {t("images")} ({images.length}/{IMAGE_RULE.maxFiles})
              </label>
              <div
                className="border border-dashed rounded-4 p-4 text-center bg-light mb-2"
                onDragOver={this.handleDragOver}
                onDrop={this.handleImageDrop}
              >
                <div className="text-secondary text-24 mb-2 icon">{""}</div>
                <div className="text-14 text-dark">
                  {t("drag_drop_files_here")} <label className="text-success fw-bold pointer mb-0">
                    {t("browse")}
                    <input type="file" multiple hidden onChange={this.handleImageBrowse} accept="image/*" />
                  </label>
                </div>
                <div className="text-12 text-secondary mt-1">
                  {formatText(t("upload_hint_images"), { count: IMAGE_RULE.maxFiles, size: toMB(IMAGE_RULE.maxSize) })}
                </div>
              </div>

              {images.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mb-3">
                  {images.map((f, idx) => (
                    <div key={idx} className="border rounded-3 p-2 text-center position-relative bg-light" style={{ width: "140px" }}>
                      {/* ปุ่มลบรูป - เดิมใช้คลาส hpx-15 ที่ไม่มีอยู่จริงใน style.css ความสูงจึงเป็น 0
                          ปุ่มเลยมองไม่เห็นและกดไม่โดน (ไอคอนข้างในก็เป็นสตริงว่าง) กำหนดขนาดเป็น inline style แทน */}
                      <div
                        role="button"
                        title={t("delete")}
                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle d-flex align-items-center justify-content-center pointer"
                        style={{ width: "22px", height: "22px", transform: "translate(30%, -30%)", zIndex: 2 }}
                        onClick={() => this.removeImage(idx)}
                      >
                        <span className="icon text-10">{"\uf00d"}</span>
                      </div>
                      <a href={f.url} target="_blank" rel="noopener noreferrer" download={f.name || undefined}>
                        <img src={f.url} alt={f.name} className="rounded-2 mb-1" style={{ width: "100%", height: "80px", objectFit: "cover" }} />
                      </a>
                      <div className="text-10 text-secondary text-truncate" title={f.name}>{f.name}</div>
                      <div className="text-10 text-secondary">{formatFileSize(f.size)}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* Videos Dropzone */}
              <label className="form-label text-13 text-secondary mb-1">
                {t("videos")} ({videos.length}/{VIDEO_RULE.maxFiles})
              </label>
              {videos.length < MAX_VIDEOS && (
                <div
                  className="border border-dashed rounded-4 p-4 text-center bg-light mb-2"
                  onDragOver={this.handleDragOver}
                  onDrop={this.handleVideoDrop}
                >
                  <div className="text-secondary text-24 mb-2 icon">{""}</div>
                  <div className="text-14 text-dark">
                    {t("drag_drop_files_here")} <label className="text-success fw-bold pointer mb-0">
                      {t("browse")}
                      <input type="file" multiple hidden onChange={this.handleVideoBrowse} accept="video/mp4,video/quicktime" />
                    </label>
                  </div>
                  <div className="text-12 text-secondary mt-1">
                    {formatText(t("upload_hint_videos"), { count: VIDEO_RULE.maxFiles, size: toMB(VIDEO_RULE.maxSize) })}
                  </div>
                </div>
              )}

              {videos.length > 0 && (
                <div className="d-flex flex-wrap gap-2">
                  {videos.map((f, idx) => (
                    <div key={idx} className="border rounded-3 p-2 position-relative bg-light" style={{ width: "180px" }}>
                      <div
                        role="button"
                        title={t("delete")}
                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle d-flex align-items-center justify-content-center pointer"
                        style={{ width: "22px", height: "22px", transform: "translate(30%, -30%)", zIndex: 2 }}
                        onClick={() => this.removeVideo(idx)}
                      >
                        <span className="icon text-10">{"\uf00d"}</span>
                      </div>
                      <video src={f.url} controls className="rounded-2 mb-1 w-100 bg-dark" style={{ height: "100px", objectFit: "contain" }} />
                      <div className="text-10 text-secondary text-truncate" title={f.name}>{f.name}</div>
                      <div className="text-10 text-secondary">{formatFileSize(f.size)}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Section 4: Contact & Schedule */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">{nextStep()}</span>
              <h6 className="fw-bold text-dark mb-0">{t("contact_schedule")}</h6>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("contact_person")}</label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  value={create_contact_name}
                  onChange={(e) => this.setState({ create_contact_name: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("phone_number")}</label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  value={create_contact_phone}
                  onChange={(e) => this.setState({ create_contact_phone: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("preferred_date")} </label>
                <input
                  type="date"
                  className="form-control rounded-3"
                  value={create_preferred_date}
                  onChange={(e) => this.setState({ create_preferred_date: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("preferred_time")}</label>
                <select
                  className="form-select rounded-3"
                  value={create_preferred_time}
                  onChange={(e) => this.setState({ create_preferred_time: e.target.value })}
                >
                  <option value="">{t("any_time")}</option>
                  <option value="morning">{t("morning")}</option>
                  <option value="afternoon">{t("afternoon")}</option>
                  <option value="evening">{t("evening")}</option>
                </select>
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="d-flex justify-content-between align-items-center pb-4">
            <button className="btn btn-white border px-4 py-2 fw-bold rounded-3" onClick={() => { window.location.href = "/cs/work-requests"; }}>
              {t("cancel")}
            </button>
            <button className="btn btn-success px-4 py-2 fw-bold rounded-3 d-flex align-items-center" onClick={this.handleSubmit}>
              <span className="icon me-2">{""}</span>{t("submit_request")}
            </button>
          </div>

          </div>
        </div>
      </div>
    );
  }
}
